

















































import { Component, Vue, Watch } from "vue-property-decorator";
import { Sticky } from "vant";
Vue.use(Sticky);
import navModel from "./model/navModel.vue";
@Component({
  components: {
    navModel,
  },
})
export default class Home extends Vue {
  public names = "";
  public path = "/";
  //   占位符
  public placeHolderTitle = ["/", "/joinUs", "/engine", "/authorization"];
  //   标题 白色背景
  public whiteTitle = [
    "/",
    "/joinUs",
    "/engine",
    "/authorization",
    "/list",
    "/search",
  ];
  //    标题黑色背景
  public blackTitle = [
    "/qualifications",
    "/",
    "/engine",
    "/news",
    "/updatelog",
    "/detail",
    "/authorization",
    "/joinUs",
  ];
  //   搜索图标
  public searchTitle = ["/updatelog", "/detail"];
  //   删除图标
  public delTitle = ["/list", "/search", "/search"];
  public linkList: any = [
    {
      name: "首页",
      path: "/",
    },
    {
      name: "资质展示",
      path: "/qualifications",
    },
    // {
    //   name: "新闻中心",
    //   path: "/news",
    // },
    {
      name: "引擎下载",
      path: "/engine",
    },
    {
      name: "新闻资讯",
      path: "/news",
    },
    {
      name: "更新日志",
      path: "/updatelog",
    },
    {
      name: "996传奇盒子",
      path: "6",
    },
    {
      name: "交流论坛",
      path: "7",
      children: [
        {
          name: "传奇论坛",
          childrenPath: "8",
        },
        {
          name: "传世论坛",
          childrenPath: "9",
        },
        {
          name: "传奇3论坛",
          childrenPath: "10",
        },
      ]
    },
    // {
    //   name: "传奇论坛",
    //   path: "7",
    // },
    // {
    //   name: "传世论坛",
    //   path: "8",
    // },
    // {
    //   name: "客户展示",
    //   path: "/according",
    // },
    {
      name: "加入我们",
      path: "/joinUs",
    },
    {
      name: "授权合作",
      path: "/authorization",
    },
  ];
  @Watch("$route")
  public change() {
    this.path = this.$route.path;
  }
  public getNavModel() {
    const $navModel: any = this.$refs.navModel;
    $navModel.show();
  }
  public getPath(data) {
    if (data.name == "996传奇盒子") {
      window.open("http://www.996box.com/", "_blank");
      return false;
    } else if (data.name == "交流论坛") {
      return false;
    }
    //  else if (data.name == "传奇论坛") {
    //   window.open("http://bbs.996m2.com/", "_blank");
    //   return false;
    // } else if (data.name == "传世论坛") {
    //   window.open("http://woool.996m2.com/", "_blank");
    //   return false;
    // }
    this.$router.push(data.path);
  }
}
